import { createContext } from "react";

export const AuthContext = createContext({
  isLoggedIn: false,
  loginVar: null,
  token: null,
  login: () => {},
  logout: () => {},
  TGRIDAMIND_isLoggedIn: false,
  TGRIDAMIND_loginVar: null,
  TGRIDAMIND_token: null,
  TGRIDAMIND_login: () => {},
  TGRIDAMIND_logout: () => {},
});
